import api from '../utilities/axios_instance';
const BACKEND_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const OPENAI_API_URL = `${BACKEND_API_URL}ai/chat`;

const formatMessageForOpenAI = (msg) => {
  const role = msg.role || (msg.sender === 'user' ? 'user' : 'assistant');
  const text = msg.text ?? msg.content ?? '';

  if (Array.isArray(msg.content)) {
    return {
      role,
      content: msg.content
    };
  }

  if (msg.image && role === 'user') {
    return {
      role,
      content: [
        { type: 'text', text },
        { type: 'image_url', image_url: { url: msg.image } }
      ]
    };
  }

  return {
    role,
    content: text
  };
};

class OpenAIService {
  static async sendMessage(messages) {
    try {
      const response = await api.post(OPENAI_API_URL, {
        messages: messages.map(formatMessageForOpenAI)
      });
      const responseData = response.data;
      const data = responseData.data || responseData; // Handle backend wrapper
      const answer = data?.answer;

      if (typeof answer === 'string') {
        return answer;
      }

      if (data?.choices?.[0]?.message?.content) {
        return data.choices[0].message.content;
      }

      throw new Error('Invalid response format from backend');
    } catch (error) {
      console.error('OpenAI Service Error:', error);
      throw new Error('Failed to get AI response. Please try again.');
    }
  }
}

export default OpenAIService;
